import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import { Navigate } from 'react-router-dom';

import { rootContext } from 'stores';
import { RouteConfig, RouteConfigs, RouteKey } from 'config/routes';
import { IUser } from 'types';
import { IsUserAllowed } from './PrivateContainer';

interface ContainerProps extends RouteConfig {
  component: React.ComponentType<any>;
}

const getPermissiblePath: (s: IUser) => string = (user: IUser) => {
  const keys = Object.keys(RouteConfigs)
  for (const key of keys) {
    const config: RouteConfig = RouteConfigs[key as RouteKey]
    if (IsUserAllowed(config, user))
      return config.path
  }
  return RouteConfigs.home.path
}


export const PublicContainer: React.FC<ContainerProps> = observer(({ component: Component, ...rest }) => {
  const {
    AuthStore: { state }
  } = useContext(rootContext);

  /**
   * @description When user is logged in and the
   * user access public routes like login/signup we
   * redirect the user to
   */
  if (state?.data?.token) {
    if (state.data.user?.userType)
      return <Navigate to={getPermissiblePath(state.data.user)} />;
  }

  return <Component {...rest} />
});